import { connect } from 'react-redux';
import Login from './Login';
import { siteLoaded } from 'state/actions/actions';

export default connect(null, { siteLoaded })(Login);
